import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FileHistoryIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="-5 -3.5 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.66797 1V4.33333C8.66797 4.55435 8.75577 4.76631 8.91205 4.92259C9.06833 5.07887 9.28029 5.16667 9.5013 5.16667H12.8346"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.168 16H2.83464C2.39261 16 1.96868 15.8244 1.65612 15.5118C1.34356 15.1993 1.16797 14.7754 1.16797 14.3333V2.66667C1.16797 2.22464 1.34356 1.80072 1.65612 1.48816C1.96868 1.17559 2.39261 1 2.83464 1H8.66797L12.8346 5.16667V14.3333C12.8346 14.7754 12.659 15.1993 12.3465 15.5118C12.0339 15.8244 11.61 16 11.168 16Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.66797 10.1693C3.66797 11.0533 4.01916 11.9012 4.64428 12.5263C5.2694 13.1514 6.11725 13.5026 7.0013 13.5026C7.88536 13.5026 8.7332 13.1514 9.35832 12.5263C9.98345 11.9012 10.3346 11.0533 10.3346 10.1693C10.3346 9.28522 9.98345 8.43737 9.35832 7.81225C8.7332 7.18713 7.88536 6.83594 7.0013 6.83594C6.11725 6.83594 5.2694 7.18713 4.64428 7.81225C4.01916 8.43737 3.66797 9.28522 3.66797 10.1693Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 8.91406V10.1674L7.83333 11.0007"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

FileHistoryIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FileHistoryIcon);
